<script>
  import ValidationMessage from '../../../components/form/ValidationMessage.vue'
  import * as authService from '../../../services/authService'

  import {mapActions} from 'vuex'
  import bus from '@utils/bus'

  import {required} from 'vuelidate/lib/validators'
  import {clone} from 'lodash'

  export default {
    components: {ValidationMessage},
    data () {
      return {
        isSubmitted: false,
        isLoadingData: true,
        form: {
          login: '',
          password: ''
        }
      }
    },
    validations: {
      form: {
        login: {required},
        password: {required}
      }
    },
    mounted () {
      this.$refs.refLogin.focus()
      bus.$emit('hide-loader')
    },
    methods: {
      ...mapActions(['login']),
      onLogin () {
        bus.$emit('show-loader')
        this.isSubmitted = true
        const data = clone(this.form)
        authService.login(data)
          .then(() => {
            this.isSubmitted = false
            bus.$emit('hide-loader')
            this.$router.push({name: 'home'})
          })
          .catch(e => {
            bus.$emit('hide-loader')
            this.isSubmitted = false
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="login-box">

        <div class="app-header">
            <figure class="logo">
                <img src="https://urcamp.edu.br/site/img/logos/logo-preto.png" alt="">
            </figure>
            <h2>Acesso ao Sistema de Eventos</h2>
            <p class="text">Acessando o seu painel você pode, se inscrever nos <strong>eventos da URCAMP</strong>,
                <strong>emitir boleto e 2ª via
                    de boleto</strong>, verificar o status das <strong>suas incrições</strong>, <strong>submeter seus
                    trabalhos</strong>, <strong>oficinas</strong>, <strong>minicursos</strong> e muito
                mais.</p>
        </div>

        <el-card class="el-card__save_form box-card">
            <el-form ref="form"
                     :model="form"
                     label-position="top"
                     v-on:submit.prevent="onLogin">
                <el-form-item label="Matrícula"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.login.$error }">
                    <el-input v-model="form.login"
                              size="large"
                              type="phone"
                              ref="refLogin"
                              @input="$v.form.login.$touch()"
                              @keyup.enter.native="onLogin"/>
                    <validation-message v-if="$v.form.login.$error"/>
                </el-form-item>
                <el-form-item label="Senha"
                              class="is-required"
                              v-bind:class="{ 'el-form-item--error': $v.form.password.$error }">
                    <el-input v-model="form.password"
                              type="password"
                              size="large"
                              @input="$v.form.password.$touch()"
                              @keyup.enter.native="onLogin"/>
                    <validation-message v-if="$v.form.password.$error"/>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary"
                               @click="onLogin"
                               size="large"
                               :disabled="isSubmitted || $v.form.$invalid">Acessar
                    </el-button>
                </el-form-item>
                <el-form-item>
                    <a href="https://sou.urcamp.edu.br/recuperacao-de-acesso" target="_blank" class="forget-password">
                        Esqueci minha senha
                    </a>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<style lang="scss" scoped>
    .login-box {
        width: 500px;
        margin: 0 auto;

        .app-header {
            display: block;
            .logo {
                img {
                    margin: 0 auto;
                    display: block;
                    width: 300px;
                    max-width: 100%;
                }
            }

            h2 {
                font-weight: 400;
                width: 100%;
                display: block;
                text-align: center;
                padding: 25px 0 10px;
            }

            .text {
                text-align: center;
                font-size: 16px;
                line-height: 24px;
                font-weight: 200;
                color: #8b8b8b;
                padding-bottom: 15px;

                strong {
                    color: #868686;
                    font-weight: 400;
                }
            }
        }

        .box-card {
            padding: 40px;
            width: 90%;
            margin: 0 auto;
        }
        .el-form {
            .el-form-item:last-child {
                margin-bottom: 0;
            }
            button {
                width: 100%;
                display: block;
                padding: 15px 0;
            }
            .forget-password {
                text-align: center;
                display: block;
                color: #888;
                text-decoration: none;
                font-weight: bold;
            }
        }
    }

    @media all and (max-width: 768px) {
        .login-box {
            width: 100%;
            padding: 0 10px;
            border: 0;
            .app-header {
                .logo {
                    img {
                        width: 200px;
                    }
                }

                h2 {
                    font-size: 22px;
                }

                .text {
                    font-size: 14px;
                    line-height: 20px;
                }
            }
            .box-card {
                width: 100%;
                padding: 10px;
                .el-card__body {
                    padding: 10px;
                }
            }
        }
    }
</style>
